import { render, staticRenderFns } from "./ThemeToggleButton.vue?vue&type=template&id=12b21e5d"
import script from "./ThemeToggleButton.vue?vue&type=script&lang=js"
export * from "./ThemeToggleButton.vue?vue&type=script&lang=js"
import style0 from "./ThemeToggleButton.vue?vue&type=style&index=0&id=12b21e5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports